<script>
    import General from '@/services/General';
    import Swal from "sweetalert2";
    import vue2Dropzone from "vue2-dropzone";
    import "vue2-dropzone/dist/vue2Dropzone.min.css";
    import Merchandising from "../../../services/Merchandising";

    export default {
        components:{  vueDropzone: vue2Dropzone   },
        props: ['id','categoryIcon','productImage','promoUrl'],
        data() {
            return {
                dir_name:'',
                showModal: false,
                tryingToEdit: false,
                submitted: false,
                showLoader:false,
                categoryId:'',
                icon:'',
                categoryProductImage:'',
                categoryPromoUrl: '',
                dropzoneOptions_icon: {
                    url: '/',
                    autoProcessQueue: false,
                    addRemoveLinks: true,
                    thumbnailWidth: 150,
                    thumbnailMethod: 'contain',
                    maxFilesize: 25,
                  //  acceptedFiles:'image/*',
                    maxFiles: 1,
                },
                dropzoneOptions_product: {
                  url: '/',
                  autoProcessQueue: false,
                  addRemoveLinks: true,
                  thumbnailWidth: 150,
                  thumbnailMethod: 'contain',
                  maxFilesize: 25,
                  //  acceptedFiles:'image/*',
                  maxFiles: 1,
                },
            };
        },


        methods: {
            syncData(){
              this.categoryId = this.id;
              this.icon = this.categoryIcon;
              this.categoryProductImage = this.productImage;
              this.categoryPromoUrl = this.promoUrl;
            },
            async uploadMedia(){
                this.tryingToEdit = true;
                this.submitted = true;
                try {
                  let formData = new FormData();
                  formData.append('id', this.categoryId)
                  formData.append('icon', this.icon)
                  formData.append('product_image', this.categoryProductImage)
                  formData.append('promo_url', this.categoryPromoUrl)


                    await Merchandising.uploadCategoryMedia(formData).then((response) => {
                        this.successmsg(response);
                        this.closeModal();
                    }).catch(error => {
                        this.error = error.response.data.error ? error.response.data.error : "";
                        this.failedmsg(this.error)
                    }).finally(() => {
                        this.refreshData()
                        this.syncData()
                        this.tryingToEdit = false;
                    })
                } catch (error) {
                    this.error = error.response.data.error ? error.response.data.error : "";
                    this.failedmsg(this.error)
                }
            },



          deleteCategoryIcon() {
            Swal.fire({
              title: "Delete Category Icon?",
              text: "This Category Icon  will be deleted!",
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#34c38f",
              cancelButtonColor: "#f46a6a",
              confirmButtonText: "Remove!",
            }).then((result) => {
              if (result.value) {
                let formData = new FormData();
                formData.append('id', this.categoryId)
                formData.append('icon', '')
                Merchandising.uploadCategoryMedia(formData)
                    .then((response) => {
                      const res = response.data ? response.data : false;
                      const error = response.data.error ? response.data.error : 'Failed';
                      if (res) {
                        this.closeModal();
                        this.refreshData()
                        Swal.fire("Remove Category Icon", "Category Icon successfully removed!", "success");
                      } else {
                        Swal.fire("Fail!", error, "warning");
                      }
                    })
                    .catch(error => {
                      this.error = error.response.data.error ? error.response.data.error : "Delete Failed";
                      this.failedmsg(this.error)
                    })
              }
            });
          },

          deleteCategoryProductImage() {
            Swal.fire({
              title: "Delete Category Product Image?",
              text: "This Category Product Image  will be deleted!",
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#34c38f",
              cancelButtonColor: "#f46a6a",
              confirmButtonText: "Remove!",
            }).then((result) => {
              if (result.value) {
                let formData = new FormData();
                formData.append('id', this.categoryId)
                formData.append('product_image', '')
                Merchandising.uploadCategoryMedia(formData)
                    .then((response) => {
                      const res = response.data ? response.data : false;
                      const error = response.data.error ? response.data.error : 'Failed';
                      if (res) {
                        this.closeModal()
                        this.refreshData()
                        Swal.fire("Remove Category Product Image", "Category Product Image successfully removed!", "success");
                      } else {
                        Swal.fire("Fail!", error, "warning");
                      }
                    })
                    .catch(error => {
                      this.error = error.response.data.error ? error.response.data.error : "Delete Failed";
                      this.failedmsg(this.error)
                    })
              }
            });
          },


            refreshData() {
                this.$emit('onRefresh') //event from parent
            },

            closeModal() {
                this.showModal = false;
                this.icon = '';
            },

            successmsg() {
                Swal.fire({
                    position: "center",
                    icon: "success",
                    title: "Category Media has been saved!",
                    showConfirmButton: false,
                    timer: 2000,
                });
            },


            failedmsg(msg) {
                Swal.fire({
                    position: "center",
                    icon: "error",
                    title: msg,
                    showConfirmButton: false,
                    timer: 5000,
                });
            },

             selectIcon(files){
                 setTimeout(() => {
                        let queuedFiles = this.$refs.myVueDropzone_icon.getQueuedFiles();

                        if (queuedFiles.length > 1) {
                            this.failedmsg('You can only have one file')

                            files.forEach((value) => {
                                this.$refs.myVueDropzone_icon.removeFile(value)
                            });
                        }

                        this.icon = queuedFiles[0];
                 }, 250);
            },
            selectProduct(files){
              setTimeout(() => {
                let queuedFiles = this.$refs.myVueDropzone_product.getQueuedFiles();

                if (queuedFiles.length > 1) {
                  this.failedmsg('You can only have one file')

                  files.forEach((value) => {
                    this.$refs.myVueDropzone_product.removeFile(value)
                  });
                }

                this.categoryProductImage = queuedFiles[0];
              }, 250);
            },
        }
    };
</script>

<template>
    <b-modal  v-model="showModal" @shown="syncData"  id="upload_category_icon" title="Upload Category Media" title-class="font-18" size="l" centered>
        <template v-if="!showLoader">
            <div class="row mb-3" >
                <div class="col-sm-12">

                        <b-form-group title="Images" title-item-class="mb-2">
                            <b-card-text class="text-center">

                                <div class="row mb-12">
                                  <div class="col-12">
                                    <h5 class="text-center">Current Category Icon</h5>
                                    <div v-if="icon" class="d-flex flex-column align-items-center justify-content-center gap-3" >
                                      <img style="width: 70px;"  :src="icon" alt="category_icon"/>
                                       <i class="fas fa-trash-alt text-danger" style="cursor: pointer;" title="Delete Category Icon" @click="deleteCategoryIcon"></i>
                                    </div>
                                    <span v-else >N/A</span>
                                  </div>
                                    <div class="col-12">
                                        <h5 class="text-center">Category Icon</h5>
                                        <vue-dropzone
                                                id="dropzone_icon"
                                                ref="myVueDropzone_icon"
                                                :use-custom-slot="true"
                                                :options="dropzoneOptions_icon"
                                                @vdropzone-files-added="selectIcon"
                                                no-progress-bar
                                        >
                                            <div class="dropzone-custom-content">
                                                <i class="display-4 text-muted bx bxs-cloud-upload"></i>
                                                <h4>Drop file here or click to upload.</h4>
                                            </div>
                                        </vue-dropzone>

                                    </div>

                                </div>

                            </b-card-text>
                        </b-form-group>
                </div>
              <div class="col-sm-12">

                <b-form-group title="Images" title-item-class="mb-2">
                  <b-card-text class="text-center">

                    <div class="row mb-12">
                      <div class="col-12">
                        <h5 class="text-center">Current Product Image</h5>
                        <div v-if="categoryProductImage" class="d-flex justify-content-center align-items-center flex-column gap-3">
                          <img  style="width: 100px;" :src="categoryProductImage" alt="product_image"/>
                          <i class="fas fa-trash-alt text-danger" style="cursor: pointer;" title="Delete Category Product Image" @click="deleteCategoryProductImage"></i>

                        </div>
                        <span v-else>N/A</span>
                      </div>
                      <div class="col-12">
                        <h5 class="text-center">Product Image</h5>
                        <vue-dropzone
                            id="dropzone_product"
                            ref="myVueDropzone_product"
                            :use-custom-slot="true"
                            :options="dropzoneOptions_product"
                            @vdropzone-files-added="selectProduct"
                            no-progress-bar
                        >
                          <div class="dropzone-custom-content">
                            <i class="display-4 text-muted bx bxs-cloud-upload"></i>
                            <h4>Drop file here or click to upload.</h4>
                          </div>
                        </vue-dropzone>
                       <div class="mt-3 d-flex align-items-start flex-column">
                         <label class="form-label" for="promo_url">Promo URL</label>
                         <input v-model="categoryPromoUrl" class="form-control" id="promo_ulr"/>
                       </div>
                      </div>

                    </div>

                  </b-card-text>
                </b-form-group>
              </div>
            </div>
        </template>
        <template v-else>
            <div class="card-body d-flex align-items-center justify-content-center" v-if="showLoader">
                <b-spinner large></b-spinner>
            </div>
        </template>
        <template v-slot:modal-footer>
            <b-button variant="light" @click="closeModal">Close</b-button>
            <b-button variant="primary" @click="uploadMedia" :disabled="tryingToEdit || showLoader">
                <b-spinner v-show="tryingToEdit" small></b-spinner>
                Upload</b-button>
        </template>
    </b-modal>
</template>